import PropTypes from "prop-types";

const CardsPoints = ({ points, selectedVendedorMes }) => {

  if (!points) return null;


  const cards = [
    {
      titulo: "Pontuação Atual",
      pontos: points.pontuacaoAtual,
      bonusSalarial: `+${Math.round(points?.percentualSalarioSemCreditoSemCampanha)?.toLocaleString('pt-BR', { minimumFractionDigits: 0 })}%`,
      sub: "do salário",
      cor: "bg-[#01054C] text-white",
    },
    {
      titulo: "Pontuação de Campanha",
      pontos: points.pontuacaoCampanha,
      bonusSalarial: "",
      sub: points.kpiCampanha ? points.kpiCampanha : "",

      cor: "bg-[#F5C115] text-black",
    },
    {
      titulo: "Pontuação Final",
      pontos: points.pontuacaoFinal,
      bonusSalarial: `+${Math.round(points?.percentualSalarioFinal)?.toLocaleString('pt-BR', { minimumFractionDigits: 0 })}%`,
      sub: "do salário",
      cor: "bg-[#389807] text-white",
    },
  ];

  return (
    <div className="flex justify-between gap-4 mt-10 cards-points-reflex">
      {cards.map((item, index) => (
        <div
          key={index}
          className={`${item.cor} rounded-xl px-6 py-12 flex-1  shadow-sm text-center`}
        >
          <h3 className="uppercase text-sm">{item.titulo}</h3>
          <p className="text-4xl font-bold pb-2 points">{parseInt(item.pontos?.replace(',', '.'), 10)} pontos</p>
          <p className="wage">
            {item.bonusSalarial} {item.sub}
          </p>
        </div>
      ))}
    </div>
  );
};

CardsPoints.propTypes = {
  points: PropTypes.shape({
    id: PropTypes.number,
    codigoVendedor: PropTypes.string,
    nomeVendedor: PropTypes.string,
    pontuacaoAtual: PropTypes.number,
    pontuacaoCampanha: PropTypes.number,
    pontuacaoFinal: PropTypes.number,
    percentualSalarioSemCreditoSemCampanha: PropTypes.number,
    percentualSalarioFinal: PropTypes.number,
  }),
};

export default CardsPoints;
